import debounce from 'lodash/debounce';
import { Component } from 'react';
import { connect } from 'react-redux';
import { FilterDropdown } from 'palette/candidates/Filters';
import { FilterGroupedItems } from 'palette/Filters';
import { SearchInput } from 'palette/SearchInput';
import { Small } from 'palette/Typography';
import { toggleFilter } from '@common/Filters/actions/filtersActions';
import { FilterTopLabel } from '@common/Filters/components/FilterTopLabel';
import { formatFilterItems } from '@common/Filters/helpers';
import latinize from '@helpers/latinize';

class ScrollFilterDropdown extends Component {
    constructor() {
        super();

        this.state = {
            searchQuery: ''
        };

        this.setQuickSearchQuery = this.setQuickSearchQuery.bind(this);
    }

    setQuickSearchQuery(event) {
        const searchQuery = event.target.value;
        this.setState({ searchQuery });
    }

    render() {
        const {
            availableFilterItems,
            activeFilters,
            filterItems,
            filterType,
            onFilterToggle
        } = this.props;
        const { searchQuery } = this.state;
        const latinizedSearchQuery = latinize(searchQuery).toLowerCase();
        // filter items with search query
        let items = filterItems.filter(item => item.nameLatinized.indexOf(latinizedSearchQuery) !== -1);

        // get count from availableFilters
        items = formatFilterItems({
            rawFilters: items,
            availableFilters: availableFilterItems,
            activeFilters
        });

        const handleFilterToggle = (clickedItem) => {
            const clickedFilter = items.find(item => item.value === clickedItem.value);

            if (clickedFilter) {
                onFilterToggle(clickedFilter);
            }
        };

        return (
            <FilterDropdown>
                <FilterTopLabel
                    filterType={filterType}
                    label={App.Translations.get('listing.filter.productseries.label')}
                />
                <div className="px-24 my-16">
                    <SearchInput
                        placeholder={App.Translations.get('search.for.label')}
                        value={searchQuery}
                        onChange={this.setQuickSearchQuery}
                    />
                    {
                        items.length === 0 && (
                            <Small
                                className="d-block mt-16"
                                color="light"
                            >
                                {App.Translations.get('search.noresults.label')}
                            </Small>
                        )
                    }
                </div>
                <FilterGroupedItems
                    items={items}
                    onToggleFilter={handleFilterToggle}
                />
            </FilterDropdown>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { dropdownFilters, availableFilters, activeFilters } = state.filters;
    const { filterType } = ownProps;
    const filterItems = dropdownFilters[filterType]
        .map(item => ({
            ...item,
            nameLatinized: latinize(item.name).toLowerCase()
        }));
    const availableFilterItems = [...availableFilters[filterType]];

    return { filterItems, availableFilterItems, activeFilters };
};

const mapDispatchToProps = dispatch => ({
    onFilterToggle: debounce((item) => {
        dispatch(toggleFilter(item));
    }, 250, {
        leading: true,
        trailing: false
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(ScrollFilterDropdown);
